module.exports = __webpack_public_path__ + "static/media/tangelo_logo.e2cee2da.png";